export default __webpack_public_path__ + "f3c6072e054b870a8436ddb4e71d967c.png";